import { convertTextToTitleCase, EQUIPMENT_STATUS_DATE_FORMAT, getMomentDate, getMomentDateTime, RESULT_STATUS } from "../constants/constants";
import moment from "moment";
import { inspectionsItem } from "../model/ActionedInspectionModel";
export class DataConvertAsync {
  public async getTableData(tableData: any) {
    return new Promise((resolve, reject) => {
      if (tableData && tableData.length > 0) {
        tableData.sort(
          (a: any, b: any) => moment(a.date).unix() - moment(b.date).unix()
        );
        let recoveredSum = 0;
        let deathSum = 0;
        let testedSum = 0;
        let positiveCases = 0;
        tableData.map((data: any) => {
          deathSum += Number(data.death);
          recoveredSum += Number(data.recovered);
          testedSum += Number(data.tested);
          positiveCases += Number(data.positiveCases);
          return null;
        });
        let lastEntry = tableData[tableData.length - 1];
        resolve({
          totalPositiveCases: Number(lastEntry.totalPositiveCases),
          activeCases: Number(lastEntry.activeCases),
          tested: Number(testedSum),
          positiveCases: Number(positiveCases),
          recovered: Number(recoveredSum),
          deaths: Number(deathSum),
        });
      }
    });
    // });
  }

  public async filterTableDataAsync(
    tableData: any,
    startDate: any,
    endDate: any
  ) {
    if (tableData && tableData.data) {
      return new Promise((resolve, reject) => {
        var dataBetween = new Array<any>();
        var compareStartDate = moment(startDate, "DD/MM/YYYY");
        var compareEndDate = moment(endDate, "DD/MM/YYYY");
        tableData.data.map((item: any) => {
          let targetDate = moment(new Date(item.date), "DD/MM/YYYY");
          let isBetween = targetDate.isBetween(
            compareStartDate,
            compareEndDate,
            "days",
            "[]"
          );
          if (isBetween) {
            dataBetween.push(item);
          }
          return null;
        });
        resolve(dataBetween);
      });
    }
  }

  public async getReferredData(inspectionsData: any) {
    return new Promise((resolve, reject) => {
      let referredData = inspectionsData.filter((inspectionItem: any) => {
        return inspectionItem.result.status === RESULT_STATUS.FAILED;
      });
      resolve(referredData);
    });
  }
  public async getTemperatureData(data: any) {
    return new Promise((resolve, reject) => {
      let referredData = Array<any>();
      data.map(async (referred: any) => {
        let tempReasons = referred.result.reasons.filter((reason: any) => {
          return reason.item === "Temperature measurement";
        });
        if (tempReasons.length > 0) {
          referredData.push(referred);
        }
      });
      resolve(referredData);
    });
  }

  public async getPersonTemperatureData(data: any) {
    return new Promise((resolve, reject) => {
      let questionItemResp = {
        id: "Temperature",
        color: "orange",
        data: Array<any>(),
      };
      let personTemperatureData = Array<any>();
      data.map((inspectionItem: any) => {
        let mDate = getMomentDate(inspectionItem.date, "DD/MM/YYYY");
        let foundObj = personTemperatureData.filter((addedItem: any) => {
          return addedItem.x === mDate;
        });
        if (inspectionItem.inspectionsItems) {
          let temperatureObjArray = inspectionItem.inspectionsItems.filter((mObj: any) => {
            return mObj.title === "Temperature";
          })
          let temperatureObj = temperatureObjArray.length > 0 ? temperatureObjArray[0] : null;
          if (foundObj.length > 0) {
            let question = temperatureObj && temperatureObj.questions && temperatureObj.questions.length > 0 ? temperatureObj.questions[0] : null;
            let numValue = question && question.value && question.value.numValue ? Number(question.value.numValue) : 0;
            foundObj[0].y += numValue;
          } else {
            let question = temperatureObj && temperatureObj.questions && temperatureObj.questions.length > 0 ? temperatureObj.questions[0] : null;
            let numValue = question && question.value && question.value.numValue ? Number(question.value.numValue) : 0;
            let mData = { x: mDate, y: numValue };
            personTemperatureData.push(mData);
          }
        }
        return null
      });
      questionItemResp.data = personTemperatureData
      resolve([questionItemResp]);
    });
  }

  getContractingTypeFromCompany = (company: any, assignedTo: any) => {
    if (!company) {
      return { name: "Not allocated" };
    }
    let result = company.contractors.filter((contractor: any) => {
      return contractor.name === assignedTo.companyName;
    });
    if (result.length > 0) {
      let contractor = result[0];
      let contractingType = company.contractingTypes.filter((item: any) => {
        return Number(item.id) === Number(contractor.contractType);
      });
      return contractingType.length > 0
        ? assignedTo.department === "Visitor"
          ? { name: "Visitors" }
          : contractingType[0]
        : { name: "Not allocated" };
    }
    return { name: "Not allocated" };
  };

  public getDataByCompanyAndDepartment(inspectionsData: any, company: any) {
    return new Promise((resolve, reject) => {
      let outputDepartmntArray = Array<any>();
      let outputCompanyArray = Array<any>();
      inspectionsData.map((inspectionItem: any) => {
        let contractType = this.getContractingTypeFromCompany(
          company,
          inspectionItem.assignedTo
        );
        let tempObjDepartment = outputDepartmntArray.filter((objItem: any) => {
          return objItem.department === inspectionItem.assignedTo.department;
        });
        let tempObjCompany = outputCompanyArray.filter((objItem: any) => {
          return objItem.contractType === contractType.name;
        });
        if (tempObjDepartment.length > 0) {
          let objItem = tempObjDepartment[0];
          objItem.Screened += 1;
          objItem.Referred +=
            inspectionItem.result.status === RESULT_STATUS.FAILED ? 1 : 0;
        } else {
          let objDepartment = {
            Referred:
              inspectionItem.result.status === RESULT_STATUS.FAILED ? 1 : 0,
            Screened: 1,
            department: inspectionItem.assignedTo.department,
          };
          outputDepartmntArray.push(objDepartment);
        }
        if (tempObjCompany.length > 0) {
          let objItem = tempObjCompany[0];
          objItem.Screened += 1;
          objItem.Referred +=
            inspectionItem.result.status === RESULT_STATUS.FAILED ? 1 : 0;
        } else {
          let objCompany = {
            Referred:
              inspectionItem.result.status === RESULT_STATUS.FAILED ? 1 : 0,
            Screened: 1,
            contractType: contractType.name,
          };
          outputCompanyArray.push(objCompany);
        }
        return null;
      });
      outputDepartmntArray.sort((a, b) => (a.x > b.x ? 1 : -1));
      outputCompanyArray.sort((a, b) => (a.x > b.x ? 1 : -1));
      resolve({
        departmentsData: outputDepartmntArray,
        companyData: outputCompanyArray,
      });
    });
  }

  public async convertToLineScreenedChartsData(
    inspectionsData: any,
    referredData: any,
    yAxisTemp?: any
  ) {
    return new Promise((resolve, reject) => {
      if (!inspectionsData) {
        reject(null);
      } else {
        let lineChartData = Array<any>();
        let questionItemResp = {
          id: "Screened",
          color: "blue",
          data: Array<any>(),
        };

        let referredQuestionItemResp = {
          id: "Referred",
          color: "red",
          data: Array<any>(),
        };

        inspectionsData.map((inspectionItem: any) => {
          let mDate = getMomentDate(inspectionItem.date, "DD/MM/YYYY");
          let foundObj = questionItemResp.data.filter((addedItem: any) => {
            return addedItem.x === mDate;
          });
          if (foundObj.length > 0) {
            foundObj[0].y += 1;
          } else {
            let mData = { x: mDate, y: 1 };
            questionItemResp.data.push(mData);
          }

          let dayHasNoReferrals = referredData.filter((filterObj: any) => {
            let compDate = getMomentDate(filterObj.date, "DD/MM/YYYY");
            return compDate === mDate;
          });
          if (dayHasNoReferrals.length > 0) {
            if (inspectionItem.result.status === RESULT_STATUS.FAILED) {
              let foundObjResp = referredQuestionItemResp.data.filter(
                (addedItem: any) => {
                  return addedItem.x === mDate;
                }
              );
              if (foundObjResp.length > 0) {
                foundObjResp[0].y += 1;
              } else {
                let mData = { x: mDate, y: 1 };
                referredQuestionItemResp.data.push(mData);
              }
            }
          } else {
            let noReferred = referredQuestionItemResp.data.filter(
              (notReferral: any) => {
                return notReferral.x === mDate;
              }
            );
            if (noReferred.length > 0) {
              noReferred[0].y = 0;
            } else {
              let mData = { x: mDate, y: 0 };
              referredQuestionItemResp.data.push(mData);
            }
          }

          return null;
        });
        questionItemResp.data.sort(
          (a, b) =>
            moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
        );
        referredQuestionItemResp.data.sort(
          (a, b) =>
            moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
        );

        let missingItems = [];
        for (var k = 0; k < questionItemResp.data.length; k++) {
          if (k > 0) {
            let prevItem = questionItemResp.data[k - 1];
            let item = questionItemResp.data[k];
            let addDayDate = moment(prevItem.x, "DD/MM/YYYY").add(1, "days");
            let mDate = getMomentDate(addDayDate.toString(), "DD/MM/YYYY");
            let currDate = moment(item.x, "DD/MM/YYYY");
            let currDateString = currDate.format("DD/MM/YYYY");
            let addDateString = addDayDate.format("DD/MM/YYYY");
            if (currDateString !== addDateString) {
              let mData = { x: mDate, y: 0 };
              missingItems.push(mData);
            }
          }
        }
        questionItemResp.data.push(...missingItems);
        questionItemResp.data.sort(
          (a, b) =>
            moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
        );

        let missingReferredItems = [];
        for (var p = 0; p < referredQuestionItemResp.data.length; p++) {
          if (p > 0) {
            let prevItem = referredQuestionItemResp.data[p - 1];
            let item = referredQuestionItemResp.data[p];
            let addDayDate = moment(prevItem.x, "DD/MM/YYYY").add(1, "days");
            let mDate = getMomentDate(addDayDate.toString(), "DD/MM/YYYY");
            let currDate = moment(item.x, "DD/MM/YYYY");
            let currDateString = currDate.format("DD/MM/YYYY");
            let addDateString = addDayDate.format("DD/MM/YYYY");
            if (currDateString !== addDateString) {
              let mData = { x: mDate, y: 0 };
              missingReferredItems.push(mData);
            }
          }
        }
        referredQuestionItemResp.data.push(...missingReferredItems);
        referredQuestionItemResp.data.sort(
          (a, b) =>
            moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
        );
        lineChartData.push(questionItemResp);
        lineChartData.push(referredQuestionItemResp);
        resolve(lineChartData);
      }
    });
  }

  private addResponse(questionItem: any, barChartData: any) {
    let GO_Color = "hsl(2, 95%, 51%)";
    let NO_GO_Color = "hsl(131, 86%, 39%)";
    let foundObj = barChartData.filter(function (e: any) {
      return e.Question === questionItem.analyticsKey;
    });
    if (foundObj.length > 0) {
      let addedObj = foundObj[0];
      let count_GO = addedObj.GO;
      let count_NO_GO = addedObj.NO_GO;
      if (questionItem.value.response === "GO") {
        count_GO = count_GO + 1;
      } else if (questionItem.value.response === "NO-GO") {
        count_NO_GO = count_NO_GO + 1;
      }
      addedObj.GO = count_GO;
      addedObj.NO_GO = count_NO_GO;
    } else {
      let questionItemResp = {
        Question: "",
        GO: 0,
        NO_GO: 0,
        GO_Color: GO_Color,
        NO_GO_Color: NO_GO_Color,
      };
      questionItemResp.Question = questionItem.analyticsKey;
      if (questionItem.value.response === "GO") {
        questionItemResp.GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "NO-GO") {
        questionItemResp.NO_GO = 1;
        barChartData.push(questionItemResp);
      }
      if (
        questionItemResp.Question.toLocaleLowerCase().includes(
          "Issued with a face mask"
        )
      ) {
        questionItemResp.NO_GO_Color = GO_Color;
        questionItemResp.GO_Color = NO_GO_Color;
      }
    }
  }

  private addResponseV2(questionItem: any, barChartData: any, shift: any) {
    let GO_Color = "green";
    let NO_GO_Color = "red";
    let GO_BUT_Color = "orange";
    let shiftColor = "hsl(215, 70%, 50%)";
    let foundObj = barChartData.filter(function (e: any) {
      return e.Question === questionItem.analyticsKey;
    });
    if (foundObj.length > 0) {
      let addedObj = foundObj[0];
      let count_GO = addedObj.GO;
      let count_NO_GO = addedObj.NO_GO;
      let count_GO_BUT = addedObj.GO_BUT;
      if (questionItem.value.response === "GO") {
        count_GO = count_GO + 1;
      } else if (questionItem.value.response === "NO-GO") {
        count_NO_GO = count_NO_GO + 1;
      } else if (questionItem.value.response === "GO-BUT") {
        count_GO_BUT = count_GO_BUT + 1;
      }
      addedObj.GO = count_GO;
      addedObj.NO_GO = count_NO_GO;
      addedObj.GO_BUT = count_GO_BUT;
    } else {
      let questionItemResp = {
        Question: "",
        GO: 0,
        NO_GO: 0,
        GO_BUT: 0,
        GO_Color: GO_Color,
        NO_GO_Color: NO_GO_Color,
        GO_BUT_Color: GO_BUT_Color,
        shiftTitle: shift.shift,
        shift: shift.count,
        shiftColor: shiftColor
      };
      questionItemResp.Question = questionItem.analyticsKey;
      if (questionItem.value.response === "GO") {
        questionItemResp.GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "NO-GO") {
        questionItemResp.NO_GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "GO-BUT") {
        questionItemResp.GO_BUT = 1;
        barChartData.push(questionItemResp);
      }
      if (
        questionItemResp.Question.toLocaleLowerCase().includes(
          "Issued with a face mask"
        )
      ) {
        questionItemResp.NO_GO_Color = GO_Color;
        questionItemResp.GO_Color = NO_GO_Color;
        questionItemResp.GO_BUT_Color = GO_BUT_Color;
      }
    }
  }


  private getResponseV2(questionItem: any, barChartData: any, shift: any) {
    let GO_Color = "green";
    let NO_Color = "red";
    let shiftColor = "hsl(215, 70%, 50%)";
    let foundObj = barChartData.filter(function (e: any) {
      return e.Question === questionItem.analyticsKey;
    });
    if (foundObj.length > 0) {
      let addedObj = foundObj[0];
      let count_GO = addedObj.GO;
      let count_NO_GO = addedObj["NO-GO"];
      var noColor = "";
      if (questionItem.value.response === "GO") {
        count_GO = count_GO + 1;
      } else if (questionItem.value.response === "NO-GO") {
        count_NO_GO = count_NO_GO + 1;
        noColor = "red"
      } else if (questionItem.value.response === "GO-BUT") {
        count_NO_GO = count_NO_GO + 1;
        noColor = "orange";
        addedObj.subCategory = "GO-BUT";
      }
      addedObj.GO = count_GO;
      addedObj["NO-GO"] = count_NO_GO;
      if (noColor) {
        addedObj["NO_Color"] = noColor
      }
    } else {
      let questionItemResp = {
        Question: "",
        GO: 0,
        "NO-GO": 0,
        subCategory: "",
        GO_Color: GO_Color,
        NO_Color: NO_Color,
        shiftTitle: shift.shift,
        shift: shift.count,
        shiftColor: shiftColor
      };
      questionItemResp.Question = questionItem.analyticsKey;
      if (questionItem.value.response === "GO") {
        questionItemResp.GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "NO-GO") {
        questionItemResp["NO-GO"] = 1;
        questionItemResp["NO_Color"] = "red"
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "GO-BUT") {
        questionItemResp["NO-GO"] = 1;
        questionItemResp["NO_Color"] = "orange";
        questionItemResp.subCategory = "GO-BUT";
        barChartData.push(questionItemResp);
      }
    }
  }


  private addGenericResponse(questionItem: any, barChartData: any) {
    let GO_Color = "hsl(2, 95%, 51%)";
    let NO_GO_Color = "hsl(131, 86%, 39%)";
    let GO_BUT_Color = "hsl(359, 70%, 50%)";
    let foundObj = barChartData.filter(function (e: any) {
      return e.Question === questionItem.analyticsKey;
    });
    if (foundObj.length > 0) {
      let addedObj = foundObj[0];
      let count_GO = addedObj.GO;
      let count_NO_GO = addedObj.NO_GO;
      let count_GO_BUT = addedObj.GO_BUT;
      if (questionItem.value.response === "GO" || questionItem.value.response === "YES") {
        count_GO = count_GO + 1;
      } else if (questionItem.value.response === "NO-GO" || questionItem.value.response === "NO") {
        count_NO_GO = count_NO_GO + 1;
      } else if (questionItem.value.response === "GO-BUT") {
        count_GO_BUT = count_GO_BUT + 1;
      }
      addedObj.GO = count_GO;
      addedObj.NO_GO = count_NO_GO;
      addedObj.GO_BUT = count_GO_BUT;
    } else {
      let questionItemResp = {
        Question: "",
        GO: 0,
        NO_GO: 0,
        GO_BUT: 0,
        GO_Color: GO_Color,
        NO_GO_Color: NO_GO_Color,
        GO_BUT_Color: GO_BUT_Color,
      };
      questionItemResp.Question = questionItem.analyticsKey;
      if (questionItem.value.response === "GO" || questionItem.value.response === "YES") {
        questionItemResp.GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "NO-GO" || questionItem.value.response === "NO") {
        questionItemResp.NO_GO = 1;
        barChartData.push(questionItemResp);
      } else if (questionItem.value.response === "GO-BUT") {
        questionItemResp.GO_BUT = 1;
        barChartData.push(questionItemResp);
      }
      if (
        questionItemResp.Question.toLocaleLowerCase().includes(
          "Issued with a face mask"
        )
      ) {
        questionItemResp.NO_GO_Color = GO_Color;
        questionItemResp.GO_Color = NO_GO_Color;
        questionItemResp.GO_BUT_Color = GO_BUT_Color;
      }
    }
  }

  public getShifts(LHDData: any) {
    let shifts = Array<any>();
    LHDData.map((inspection: any) => {
      let headerItem: any = inspection.shift.length > 0 ? inspection.shift[0] : null;
      if (headerItem) {
        let foundObj = shifts.filter(function (e: any) {
          return e.shift === headerItem.value;
        });
        if (foundObj && foundObj.length > 0) {
          let addedObj = foundObj[0];
          addedObj.count += 1;
          addedObj.inspections.push(inspection);
        } else {
          let shift = {
            shift: headerItem.value,
            count: 1,
            inspections: Array<any>()
          }
          shift.inspections.push(inspection);
          shifts.push(shift);
        }
      }
      return null;
    });
    return shifts;
  }

  public convertToPreUseBarData(LHDData: any, allShifts?: any) {
    return new Promise((resolve, reject) => {
      if (LHDData && LHDData.length > 0) {
        let barData = Array<any>();
        let shifts = this.getShifts(LHDData);
        shifts.forEach((shift: any) => {
          let barChartData = Array<any>();
          shift.inspections.forEach((inspection: any) => {
            inspection.inspectionsItems.forEach((inspectionItem: any) => {
              inspectionItem.questions.forEach((questionItem: any) => {
                this.addResponseV2(questionItem, barChartData, shift);
              });
            });
            return null;
          });
          barData.push(barChartData);
          return null;
        });
        if (allShifts) {
          let allShiftData = Array<any>();
          barData.forEach((item: any) => {
            item.forEach((subItem: any) => {
              let foundObj = allShiftData.filter((obj: any) => { return obj.Question === subItem.Question });
              if (foundObj && foundObj.length > 0) {
                let addedObj = foundObj[0];
                addedObj.GO += subItem.GO;
                addedObj.GO_BUT += subItem.GO_BUT;
                addedObj.NO_GO += subItem.NO_GO
              } else {
                subItem.shiftTitle = "All Shifts";
                allShiftData.push(subItem);
              }
            })
          })
          resolve([allShiftData]);
        } else {
          resolve(barData);
        }
      }
    });
  }


  public convertToPreUseBarDataTemp(LHDData: any, allShifts?: any) {
    return new Promise((resolve, reject) => {
      if (LHDData && LHDData.length > 0) {
        let barData = Array<any>();
        let shifts = this.getShifts(LHDData);
        shifts.forEach((shift: any) => {
          let barChartData = Array<any>();
          shift.inspections.forEach((inspection: any) => {
            inspection.inspectionsItems.forEach((inspectionItem: any) => {
              inspectionItem.questions.forEach((questionItem: any) => {
                this.getResponseV2(questionItem, barChartData, shift);
              });
            });
          });
          barData.push(barChartData);
        });
        if (allShifts) {
          let allShiftData = Array<any>();
          barData.forEach((item: any) => {
            item.forEach((subItem: any) => {
              let foundObj = allShiftData.filter((obj: any) => { return obj.Question === subItem.Question });
              if (foundObj && foundObj.length > 0) {
                let addedObj = foundObj[0];
                addedObj.GO += subItem.GO;
                if (subItem["NO-GO"] > 0) {
                  addedObj["NO-GO"] += subItem["NO-GO"]
                }
                if (subItem["GO-BUT"] > 0) {
                  addedObj["GO-BUT"] += subItem["GO-BUT"];
                }
              } else {
                subItem.shiftTitle = "All Shifts";
                allShiftData.push(subItem);
              }
            })
          })
          resolve([allShiftData]);
        } else {
          resolve(barData);
        }
      } else {
        resolve([]);
      }
    });
  }

  public convertToGenericBarData(genericData: any, equipment?: any) {
    return new Promise((resolve, reject) => {
      let barChartData = Array<any>();
      if (genericData && genericData.length > 0) {
        genericData.map((inspection: any) => {
          if (equipment) {
            if (inspection.machineDetails && inspection.machineDetails.name === equipment) {
              for (var i = 0; i < inspection.inspectionsItems.length; i++) {
                let inspectionItem = inspection.inspectionsItems[i];
                inspectionItem.questions.forEach((questionItem: any) => {
                  this.addGenericResponse(questionItem, barChartData);
                });
              }
            }
          } else {
            for (var j = 0; j < inspection.inspectionsItems.length; j++) {
              let inspectionItem = inspection.inspectionsItems[j];
              inspectionItem.questions.forEach((questionItem: any) => {
                this.addGenericResponse(questionItem, barChartData);
              });
            }
          }
          return null;
        });
        resolve(barChartData);
      }
    });
  }

  public convertToGenericBarDataByInspection(inspectionData: any, selectedInspection?: any) {
    return new Promise((resolve, reject) => {
      if (inspectionData && inspectionData.length > 0) {
        let barChartData = inspectionData.filter((inspection: any) => {
          return inspection.name === selectedInspection
        });
        let mBar = this.convertToGenericBarData(barChartData);
        resolve(mBar);
      }
    });
  }

  getIndicatorObj = (inspection: any) => {
    let shift = inspection.shift && inspection.shift.length > 0 ? inspection.shift[0] : "";
    let indicatorObj = { shift: "", indicator: "", date: "" };
    if (shift) {
      indicatorObj.shift = shift.value;
      let indicator = "green";
      inspection.inspectionsItems.map((inspectionItem: any) => {
        inspectionItem.questions.forEach((questionItem: any) => {
          if (questionItem.value.response === "GO-BUT" && indicator !== "red") {
            indicator = "orange";
          }
          else if (questionItem.value.response === "NO" || questionItem.value.response === "NO-GO") {
            indicator = "red"
          }
          return null;
        });
        return null
      })
      indicatorObj.indicator = indicator;
    }


    return indicatorObj;
  }

  getPreUseMachineData(PreUseData: any) {
    return new Promise((resolve, reject) => {
      let displayData = new Array<any>();
      if (PreUseData && PreUseData.length > 0) {
        PreUseData.map((inspection: any) => {
          let mDate = getMomentDate(inspection.date, "DD/MM/YYYY");
          let headerItem: any = inspection.machine.length > 0 ? inspection.machine[0] : null;
          if (headerItem) {
            let foundObj = displayData.filter(function (e: any) {
              return e.machine === headerItem.value;
            });
            if (foundObj && foundObj.length > 0) {
              let addedObj = foundObj[0];
              let mUtilisationData = {
                y: inspection.utilisationPercentage,
                x: mDate
              }
              let mAvailabilityData = {
                y: inspection.availabilityPercentage,
                x: mDate
              }

              let mQualityData = {
                y: 100,
                x: mDate
              }

              let mOEEData = {
                y: inspection.OEE,
                x: mDate
              }
              addedObj.preuseData.push(inspection);
              addedObj.utilisationData.push(mUtilisationData);
              addedObj.availabilityData.push(mAvailabilityData);
              addedObj.qualityData.push(mQualityData);
              addedObj.OEEData.push(mOEEData);
            } else {
              let addedItem = {
                date: inspection.date,
                machine: headerItem.value,
                machineStatusData: new Array<any>(),
                preuseData: new Array<any>(),
                utilisationData: new Array<any>(),
                availabilityData: new Array<any>(),
                qualityData: new Array<any>(),
                OEEData: new Array<any>()
              };
              let mUtitlisationData = {
                y: inspection.utilisationPercentage,
                x: mDate
              }

              let mAvailabilityData = {
                y: inspection.availabilityPercentage,
                x: mDate
              }

              let mQualityData = {
                y: 100,
                x: mDate
              }

              let mOEEData = {
                y: inspection.OEE,
                x: mDate
              }
              addedItem.preuseData.push(inspection);
              addedItem.utilisationData.push(mUtitlisationData);
              addedItem.availabilityData.push(mAvailabilityData);
              addedItem.qualityData.push(mQualityData);
              addedItem.OEEData.push(mOEEData);
              displayData.push(addedItem);
            }
          }
          return null;
        });
        displayData.sort((a, b) => (a.machine > b.machine ? 1 : -1));
        resolve(displayData);
      }
    }
    );
  }

  getPreUseMachineStatusData(PreUseData: any, machineName?: any) {
    return new Promise((resolve, reject) => {
      let displayData = new Array<any>();
      if (PreUseData && PreUseData.length > 0) {
        PreUseData.map((inspection: any) => {
          let headerItem: any = inspection.machine.length > 0 ? inspection.machine[0] : null;
          if (machineName && headerItem && headerItem.value !== machineName) {
            headerItem = null;
          }
          if (headerItem) {
            let foundObj = displayData.filter(function (e: any) {
              return e.machine === headerItem.value;
            });
            if (foundObj && foundObj.length > 0) {
              let addedObj = foundObj[0];
              let indicatorObj = this.getIndicatorObj(inspection);
              indicatorObj.date = getMomentDate(inspection.date, EQUIPMENT_STATUS_DATE_FORMAT);
              addedObj.machineStatusData.push(indicatorObj)
            } else {
              let addedItem = {
                machine: headerItem.value,
                machineStatusData: new Array<any>(),
              };
              let indicatorObj = this.getIndicatorObj(inspection);
              indicatorObj.date = getMomentDate(inspection.date, EQUIPMENT_STATUS_DATE_FORMAT);
              addedItem.machineStatusData.push(indicatorObj)
              displayData.push(addedItem);
            }
          }
          return null;
        });
        displayData.sort((a, b) => (a.machine > b.machine ? 1 : -1));
        resolve(displayData);
      }
    }
    );
  }

  getPreUseMachineEffectivenessData(LHDData: any, comparisonData: any) {
    return new Promise((resolve, reject) => {
      let perfomanceData = new Array<any>();
      let OEEData = new Array<any>();
      let qualityData = new Array<any>();
      let availabilityData = new Array<any>();
      if (LHDData && LHDData.length > 0) {
        LHDData.map((inspection: any) => {
          let mDate = getMomentDate(inspection.date, "DD/MM/YYYY");
          if (mDate === comparisonData) {
            let headerItem: any = inspection.machine.length > 0 ? inspection.machine[0] : null;
            let mPerfomanceData = {
              x: headerItem.value,
              y: inspection.utilisationPercentage,
            }
            perfomanceData.push(mPerfomanceData);
            let mQualityData = {
              x: headerItem.value,
              y: 100,
            }
            qualityData.push(mQualityData);
            let mAvailabilityData = {
              x: headerItem.value,
              y: inspection.availabilityPercentage,
            }
            availabilityData.push(mAvailabilityData);
            let mOEEData = {
              x: headerItem.value,
              y: inspection.OEE,
            }
            OEEData.push(mOEEData);
          }
          return null;
        });
        perfomanceData.sort((a, b) => (a.machine > b.machine ? 1 : -1));
        let result = [{ perfomanceData: perfomanceData, availabilityData: availabilityData, qualityData: qualityData, OEEData: OEEData }]
        resolve(result);
      }
    }
    );
  }
  getPreUseComplianceData(LHDData: any) {
    return new Promise((resolve, reject) => {
      let yesColor = "green";
      let noColor = "red";
      let complianceData = new Array<any>();
      if (LHDData && LHDData.length > 0) {
        LHDData.map((inspection: any) => {
          inspection.signotoriesItems.map((signotoriesItem: any) => {
            let foundObj = complianceData.filter(function (e: any) {
              return convertTextToTitleCase(e.who) === convertTextToTitleCase(signotoriesItem.who);
            });
            if (foundObj && foundObj.length > 0) {
              let addedObj = foundObj[0];
              let value = signotoriesItem.value ? signotoriesItem.value : "";
              if (value && value.fullName) {
                addedObj["Signed"] += 1;
              } else {
                addedObj["Not Signed"] += 1;
              }
            } else {
              let itemResp = {
                who: convertTextToTitleCase(signotoriesItem.who),
                "Signed": 0,
                "Not Signed": 0,
                YESColor: yesColor,
                NOColor: noColor,
              };
              let value = signotoriesItem.value ? signotoriesItem.value : "";
              if (value && value.fullName) {
                itemResp["Signed"] = 1;
                complianceData.push(itemResp);
              } else {
                itemResp["Not Signed"] = 1;
                complianceData.push(itemResp);
              }
            }
            return null;
          })
          return null;
        })
      }
      resolve(complianceData)
    });
  }
  getTimeDifferenceFromTime = (timeStart: any, timeEnd: any) => {
    let start_dateString = `${new Date().toDateString()} ${timeStart}`;
    let end_dateString = `${new Date().toDateString()} ${timeEnd}`;
    var startOfShift = moment(Date.parse(start_dateString));
    var endOfShift = moment(Date.parse(end_dateString));

    if (timeStart.includes("PM") && timeEnd.includes("AM")) {
      endOfShift.add(1, "d");
    }
    var duration = moment.duration(endOfShift.diff(startOfShift));
    var minutes = duration.asMinutes();
    return minutes;
  }

  getDaysBetweenTwoDates = (startDate: any, endDate: any, isOpp?: any) => {
    var dates = [];
    var currDate = moment(startDate).startOf('day');
    dates.push(currDate.toDate())
    var lastDate = moment(endDate).startOf('day');
    let diffDays = moment.duration(currDate.diff(lastDate)).asDays();
    if (diffDays < 0) {
      while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.clone().toDate());
      }
      dates.push(lastDate.toDate());
      if (isOpp) {
        dates.sort((a, b) => moment(b).unix() - moment(a).unix());
      }
    }
    return dates;
  }

  getPreUseBreakdownData(LHDData: any) {
    return new Promise((resolve, reject) => {
      let countColor = "hsl(2, 95%, 51%)";
      let breakdownData = new Array<any>();
      if (LHDData && LHDData.length > 0) {
        LHDData.map((inspection: any) => {
          if (inspection.breakdowns) {
            inspection.breakdowns.map((breakdownItem: any) => {
              let foundObj = breakdownData.filter(function (e: any) {
                return e.title.toLowerCase() === breakdownItem.title.toLowerCase();
              });
              let availabilityLoss = this.getTimeDifferenceFromTime(breakdownItem["Time of breakdown"], breakdownItem["Time back in operation"]);
              if (foundObj && foundObj.length > 0) {
                let addedObj = foundObj[0];
                addedObj.Breakdown += availabilityLoss;
                addedObj.Breakdown = Number(addedObj.Breakdown.toFixed(2));
              } else {
                let itemResp = {
                  title: breakdownItem.title,
                  Breakdown: 0,
                  COUNTColor: countColor,
                };
                itemResp.Breakdown = Number(availabilityLoss.toFixed(2));
                breakdownData.push(itemResp);
              }
              return null;
            })
          }
          return null;
        })
      }
      resolve(breakdownData)
    });
  }

  getPreUseStandingData(LHDData: any) {
    return new Promise((resolve, reject) => {
      let countColor = "hsl(2, 95%, 51%)";
      let standingData = new Array<any>();
      if (LHDData && LHDData.length > 0) {
        LHDData.map((inspection: any) => {
          if (inspection.standings) {
            inspection.standings.map((standingItem: any) => {
              let foundObj = standingData.filter(function (e: any) {
                return e.title.toLowerCase() === standingItem.title.toLowerCase();
              });
              let standingLoss = this.getTimeDifferenceFromTime(standingItem["Time started standing"], standingItem["Time started operating"]);
              if (foundObj && foundObj.length > 0) {
                let addedObj = foundObj[0];
                addedObj.Standing += standingLoss;
              } else {
                let itemResp = {
                  title: standingItem.title,
                  Standing: 0,
                  COUNTColor: countColor,
                };
                itemResp.Standing = standingLoss;
                standingData.push(itemResp);
              }
              return null;
            })
          }
          return null;
        })
      }
      resolve(standingData)
    });
  }

  getBarDisplayData(data: any) {
    let displayData = new Array<any>();
    data.map((item: any) => {
      item.map((dataItem: any, index: any) => {
        let foundObj = displayData.filter(function (e: any) {
          return e.question === dataItem.Question;
        });
        if (foundObj && foundObj.length > 0) {
          let addedObj = foundObj[0];
          let title = dataItem.shiftTitle;
          let titleColor = `${title}Color`;
          let itemDataGoString = `{"question": "${dataItem.Question}","${title}":${dataItem.GO + dataItem.NO_GO},"${titleColor}": "hsl(215, 70%, 50%)"}`;
          let itemDataGo = JSON.parse(itemDataGoString);
          addedObj = Object.assign(addedObj, itemDataGo);
          displayData.splice(index, 1, addedObj);
        } else {
          let title = dataItem.shiftTitle;
          let titleColor = `${title}Color`;
          let itemDataGoString = `{
        "question": "${dataItem.Question}",
        "${title}": ${dataItem.GO + dataItem.NO_GO},
        "${titleColor}": "hsl(215, 70%, 50%)"
      }`
          let itemDataGo = JSON.parse(itemDataGoString);
          displayData.push(itemDataGo);
        }
        return null;
      })
      return null;
    });
    return displayData;
  }


  getWorkflowProcessChartData(workflowData: any) {
    return new Promise((resolve, reject) => {
      let countColor = "hsl(2, 95%, 51%)";
      let resultWorkflowData = new Array<any>();
      let resultPerStepsWorkflowData = new Array<any>();
      if (workflowData && workflowData.length > 0) {
        workflowData.map((inspection: any) => {
          if (inspection.workflows) {
            inspection.workflows.map((workflowItem: any) => {
              let stepObj = { stepName: workflowItem.stepName, subSteps: new Array<any>() };
              let totalTimeSubSteps = 0;
              let minToSubtract = Math.floor(Math.random() * (60 - 5) + 5);
              let timeStarted = moment(workflowItem.workflow.assign.receivedOn)
              timeStarted.subtract(minToSubtract, "minutes");
              workflowItem.workflow.inspection.inspectionsItems.map((inspectionItem: any) => {
                let subSteps = new Array<any>();
                inspectionItem.questions.map((questionItem: any) => {
                  let currentTime = moment(questionItem.value.timeCaptured);
                  currentTime.add(minToSubtract, "minutes")
                  let stepTime = moment.duration(currentTime.diff(timeStarted)).minutes()
                  totalTimeSubSteps += stepTime;
                  let subStep = {
                    title: questionItem.question,
                    TotalTime: totalTimeSubSteps,
                  }
                  subSteps.push(subStep)
                })
                stepObj.subSteps = subSteps;
              })
              let itemResp = {
                title: workflowItem.stepName,
                TotalTime: totalTimeSubSteps,
                COUNTColor: countColor,
              };
              resultWorkflowData.push(itemResp);
              resultPerStepsWorkflowData.push(stepObj)
              return null;
            })
          }
          return null;
        })
      }
      let fullSteps = new Array<any>();

      resultWorkflowData.map((mItem: any) => {
        let foundObj = fullSteps.filter(function (e: any) {
          return e.title.toLowerCase() === mItem.title.toLowerCase();
        });
        if (foundObj && foundObj.length > 0) {
          let addedObj = foundObj[0];
          addedObj.TotalTime += mItem.TotalTime;
        } else {
          let subStep = {
            title: mItem.title,
            TotalTime: mItem.TotalTime
          }
          fullSteps.push(subStep)
        }
      })
      let fullSubSteps = new Array<any>();
      resultPerStepsWorkflowData.map((mItem: any) => {
        let foundObj = fullSubSteps.filter(function (e: any) {
          return e.stepName.toLowerCase() === mItem.stepName.toLowerCase();
        });
        if (foundObj && foundObj.length > 0) {
          let addedObj = foundObj[0];
          addedObj.subSteps.map((addSubStepItem: any) => {
            mItem.subSteps.map((subStepItem: any) => {
              if (addSubStepItem.title === subStepItem.title) {
                addSubStepItem.TotalTime += subStepItem.TotalTime;
              }
            })
          })
        } else {
          let subStep = {
            stepName: mItem.stepName,
            subSteps: mItem.subSteps
          }
          fullSubSteps.push(subStep)
        }
      })
      resolve({ all: fullSteps, subSteps: fullSubSteps })
    });
  }

  public convertToBarChartsData(
    inspectionsData: any,
    questionsResponsesData: any
  ) {
    return new Promise((resolve, reject) => {
      if (questionsResponsesData && questionsResponsesData.length > 0) {
        let barChartData = Array<any>();
        let yesColor = "hsl(2, 95%, 51%)";
        let noColor = "hsl(131, 86%, 39%)";
        questionsResponsesData.map((inspectionItem: any) => {
          inspectionItem.questions.map((questionItem: any) => {
            let foundObj = barChartData.filter(function (e) {
              return e.Question === questionItem.analyticsKey;
            });
            if (foundObj.length > 0) {
              let addedObj = foundObj[0];
              let countYES = addedObj.YES;
              let countNO = addedObj.NO;
              if (questionItem.value === "YES") {
                countYES = countYES + 1;
              } else if (questionItem.value === "NO") {
                countNO = countNO + 1;
              }
              addedObj.YES = countYES;
              addedObj.NO = countNO;
            } else {
              let questionItemResp = {
                Question: "",
                YES: 0,
                NO: 0,
                YESColor: yesColor,
                NOColor: noColor,
              };
              questionItemResp.Question = questionItem.analyticsKey;
              if (questionItem.value === "YES") {
                questionItemResp.YES = 1;
                barChartData.push(questionItemResp);
              } else if (questionItem.value === "NO") {
                questionItemResp.NO = 1;
                barChartData.push(questionItemResp);
              }
              if (
                questionItemResp.Question.toLocaleLowerCase().includes(
                  "Issued with a face mask"
                )
              ) {
                questionItemResp.NOColor = yesColor;
                questionItemResp.YESColor = noColor;
              }
            }
            return null;
          });

          return null;
        });
        resolve(barChartData);
      }
    });
  }
}
